import { create } from 'zustand';

export type NotificationType =
  | 'workflow_failed'
  | 'approval_pending'
  | 'convergence_dropped'
  | 'info';

export interface Notification {
  id: string;
  type: NotificationType;
  title: string;
  message: string;
  timestamp: number;
  read: boolean;
  link?: string;
}

interface NotificationStoreState {
  notifications: Notification[];
  unreadCount: number;
  addNotification: (notif: Omit<Notification, 'id' | 'read' | 'timestamp'>) => void;
  markRead: (id: string) => void;
  markAllRead: () => void;
  clearAll: () => void;
}

const MAX_NOTIFICATIONS = 50;

export const useNotificationStore = create<NotificationStoreState>()(set => ({
  notifications: [],
  unreadCount: 0,

  addNotification: (notif): void => {
    set(state => {
      const newNotification: Notification = {
        ...notif,
        id: crypto.randomUUID(),
        read: false,
        timestamp: Date.now(),
      };
      const updated = [newNotification, ...state.notifications].slice(0, MAX_NOTIFICATIONS);
      return {
        notifications: updated,
        unreadCount: updated.filter(n => !n.read).length,
      };
    });
  },

  markRead: (id): void => {
    set(state => {
      const notifications = state.notifications.map(n => (n.id === id ? { ...n, read: true } : n));
      return {
        notifications,
        unreadCount: notifications.filter(n => !n.read).length,
      };
    });
  },

  markAllRead: (): void => {
    set(state => ({
      notifications: state.notifications.map(n => ({ ...n, read: true })),
      unreadCount: 0,
    }));
  },

  clearAll: (): void => {
    set({ notifications: [], unreadCount: 0 });
  },
}));
